// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.dati .p-inputtext{
  width: 100%;
}


.icobutton
{
    padding: 0.2rem 0.2rem;
    background-color: #0a568d;
    color:#00adef;  
}


.dati{
    padding: 0.2rem;
    display: flex;
    flex-direction: column;
    margin-right: 0.3rem;
    margin-bottom: 0.3rem;
    float: left;
}
.p-dialog, p.dialog-header,p.dialog-content
{
  background-color: #171717;
  color: #48d4d6;  
  border-color: #48d4d6;
  border-radius: 10px;
  border-width: 2px;
}  

.p-dialog .p-dialog-header
{
  background-color:#050505;
  color: #48d4d6;  
  font-weight: 900;
  font-size: 2rem; 
  padding: 0.3rem;
  margin-bottom: 0.5rem;
}
.p-dialog .p-dialog-footer
{
  background-color:  #171717;
  color: #48d4d6;  
  font-weight: 900;
  font-size: 2rem;
}
.p-confirm-dialog
{
  background-color: #171717;
  color: #48d4d6;  
  border-color: #48d4d6;
  border-radius: 10px;
  border-width: 2px;
  border: solid;
  max-width: 85%;
  padding: 1.5em;
}
.p-dialog .p-dialog-content
{
  background-color: #171717;
  color:white;  
  font-size: 1.3rem; 
     padding: 0 0.5rem 2rem 0.5rem;
     justify-content: center;

}
.p-confirm-dialog button{
    width: 4em;
}

.p-icon-field
{
  display: flex;
  align-items: center;
  padding: 0;
  padding-left: 0.3rem;
  
  
    border-radius: 10px;
}

.p-icon-field .p-inputnumber
{
  margin:0px;
  margin-left: 0.3rem;
}
.p-icon-field-left > .p-inputtext {
padding-left: 2rem;
}



.listaConv
{
  color:#2E75B6;
  background-color: transparent;     
  width:100%;
  column-count:2;
  padding:12px;
  -webkit-column-count: 2;
   -moz-column-count: 2;
   padding-top:15px;
   column-gap: 0;  
}


div.listaConv > div:nth-of-type(even)
{
  padding:5px 8px;
  background-color: #e1f2f9;   
}
div.listaConv > div:nth-of-type(odd)
{
  padding:5px 8px;
  background-color: white;   
}
`, "",{"version":3,"sources":["webpack://./src/stili/App01.css"],"names":[],"mappings":";;AAEA;EACE,WAAW;AACb;;;AAGA;;IAEI,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;AACjB;;;AAGA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;AACf;AACA;;EAEE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;AACA;;EAEE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;KACd,6BAA6B;KAC7B,uBAAuB;;AAE5B;AACA;IACI,UAAU;AACd;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,oBAAoB;;;IAGlB,mBAAmB;AACvB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;AACA;AACA,kBAAkB;AAClB;;;;AAIA;;EAEE,aAAa;EACb,6BAA6B;EAC7B,UAAU;EACV,cAAc;EACd,YAAY;EACZ,uBAAuB;GACtB,oBAAoB;GACpB,gBAAgB;GAChB,aAAa;AAChB;;;AAGA;;EAEE,eAAe;EACf,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,uBAAuB;AACzB","sourcesContent":["\n\n.dati .p-inputtext{\n  width: 100%;\n}\n\n\n.icobutton\n{\n    padding: 0.2rem 0.2rem;\n    background-color: #0a568d;\n    color:#00adef;  \n}\n\n\n.dati{\n    padding: 0.2rem;\n    display: flex;\n    flex-direction: column;\n    margin-right: 0.3rem;\n    margin-bottom: 0.3rem;\n    float: left;\n}\n.p-dialog, p.dialog-header,p.dialog-content\n{\n  background-color: #171717;\n  color: #48d4d6;  \n  border-color: #48d4d6;\n  border-radius: 10px;\n  border-width: 2px;\n}  \n\n.p-dialog .p-dialog-header\n{\n  background-color:#050505;\n  color: #48d4d6;  \n  font-weight: 900;\n  font-size: 2rem; \n  padding: 0.3rem;\n  margin-bottom: 0.5rem;\n}\n.p-dialog .p-dialog-footer\n{\n  background-color:  #171717;\n  color: #48d4d6;  \n  font-weight: 900;\n  font-size: 2rem;\n}\n.p-confirm-dialog\n{\n  background-color: #171717;\n  color: #48d4d6;  \n  border-color: #48d4d6;\n  border-radius: 10px;\n  border-width: 2px;\n  border: solid;\n  max-width: 85%;\n  padding: 1.5em;\n}\n.p-dialog .p-dialog-content\n{\n  background-color: #171717;\n  color:white;  \n  font-size: 1.3rem; \n     padding: 0 0.5rem 2rem 0.5rem;\n     justify-content: center;\n\n}\n.p-confirm-dialog button{\n    width: 4em;\n}\n\n.p-icon-field\n{\n  display: flex;\n  align-items: center;\n  padding: 0;\n  padding-left: 0.3rem;\n  \n  \n    border-radius: 10px;\n}\n\n.p-icon-field .p-inputnumber\n{\n  margin:0px;\n  margin-left: 0.3rem;\n}\n.p-icon-field-left > .p-inputtext {\npadding-left: 2rem;\n}\n\n\n\n.listaConv\n{\n  color:#2E75B6;\n  background-color: transparent;     \n  width:100%;\n  column-count:2;\n  padding:12px;\n  -webkit-column-count: 2;\n   -moz-column-count: 2;\n   padding-top:15px;\n   column-gap: 0;  \n}\n\n\ndiv.listaConv > div:nth-of-type(even)\n{\n  padding:5px 8px;\n  background-color: #e1f2f9;   \n}\ndiv.listaConv > div:nth-of-type(odd)\n{\n  padding:5px 8px;\n  background-color: white;   \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
